import request from '@/utils/request'

// 获取指定学校的校区和楼栋数据：
const getSchoolBuilding = (params) => {
  return request({
    url: `admin/building/tree`,
    method: 'get',
    params,
  })
}

// 编辑楼栋
const updateBuilding = (params) => {
  return request({
    url: `/admin/building/update`,
    method: 'post',
    params,
  })
}

// 楼栋排序
const sortBuilding = (params) => {
  return request({
    url: `/admin/building/sort`,
    method: 'post',
    data: params,
  })
}

// 新建楼栋
const creatBuilding = (params) => {
  return request({
    url: `/admin/building/create`,
    method: 'post',
    params,
  })
}

// 删除楼栋
const delCurrentBuilding = (params) => {
  return request({
    url: `/admin/building/delete`,
    method: 'post',
    params,
  })
}

// 新建校区
const creatCampus = (params) => {
  return request({
    url: `/admin/campus/create`,
    method: 'post',
    params,
  })
}

// 编辑校区
const updateCampus = (params) => {
  return request({
    url: `/admin/campus/update`,
    method: 'post',
    params,
  })
}

// 删除校区
const deleteCampus = (params) => {
  return request({
    url: `/admin/campus/delete`,
    method: 'post',
    params,
  })
}
// 校区排序
const sortCampus = (params) => {
  return request({
    url: `/admin/campus/sort`,
    method: 'post',
    data: params,
  })
}

export default {
  getSchoolBuilding,
  updateBuilding,
  sortBuilding,
  creatBuilding,
  delCurrentBuilding,
  creatCampus,
  updateCampus,
  deleteCampus,
  sortCampus
}
